import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import domain from './domainDetector.js';

// Import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import enTopologies from '../locales/en/topologies.js';
import enMain from '../locales/en/main';
import enErrorMessages from '../locales/en/errorMessages.js';

import cnMain from '../locales/cn/main_CN.json';
import cnTopologies from '../locales/cn/topologies_CN.js';
import cnErrorMessages from '../locales/cn/errorMessages_CN.js';

const languagedetector = new LanguageDetector();
languagedetector.addDetector(domain);

const options = {
	order: ['querystring', 'domain'],
	lookupQuerystring: 'lng'
};

const resources = {
	en: {
		main: enMain,
		topologies: enTopologies,
		errors: enErrorMessages
	},
	cn: {
		main: cnMain,
		topologies: cnTopologies,
		errors: cnErrorMessages
	}
};

i18n // .use(Backend)
	.use(languagedetector)
	.use(initReactI18next)
	.init({
		detection: options,
		resources,
		defaultNS: 'main',
		fallbackLng: 'en',
		debug: process.env.NODE_ENV !== 'production',
		interpolation: {
			escapeValue: false // Not needed for react as it escapes by default
		}
	});

export default i18n;
